import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {Badge, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuHistory, LuInfo, LuSyringe} from 'react-icons/lu'

export function SolutionDrawerTabsList() {
  const {t} = useTranslate('common')
  const {solutionDrug} = useSolutionDrugContext()

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="medication-profiles" data-e2e="medication-profiles-trigger">
        <LuSyringe />
        {t('medicine_forms')}
        <Badge size="xs">{solutionDrug.medicationProfiles?.length || 0}</Badge>
      </Tabs.Trigger>

      <Tabs.Trigger value="history" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
